export default __webpack_public_path__ + "static/media/logo.01fdc9a9.svg";